import React, { PureComponent } from "react";
import classnames from "classnames";
import Sidebar from "./sidebar/sidebar";
import Navbar from "./navigationBar/NavigationBar";
import templateConfig from "../templateConfig";
import { utils } from "../utils";
import EventEmitter, { Events } from "../services/eventemitter";
import { OverlayPanel } from 'primereact/overlaypanel';
import { LoginResponse } from "../models";
import { wglcsApiService } from "../services/WglcsApiService";
import { Interfaces } from "../constants/Interfaces";
import CannedWorker from "../workers/CannedWorker";
import { DetectEnvironment } from "../EnvironmentSettings";
import { cookieService } from "../services/CookieService";

const { detect } = require("detect-browser");
const browser = detect();

class MainLayout extends PureComponent<{}, {}> {
    notificationHelpOverLay: any | null;
    userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;

    constructor(props) {
        super(props);

        this.notificationHelpOverLay = React.createRef();
        EventEmitter.on(Events.refershCanned, this.refreshCannedMessage);
    }

    state = {
        width: window.innerWidth,
        sidebarState: "close",
        sidebarSize: "",
        layout: "layout-light",
        showNotificationIcon: false,
        callBackValue: '',
        isChildWindow: false,
        refreshState: 0,
        layoutMaskValue: '',
    };

    updateWidth = () => {
        this.setState((prevState) => ({
            width: window.innerWidth,
        }));
    };

    handleSidebarSize = (sidebarSize) => {
        this.setState({ sidebarSize });
    };

    handleLayout = (value) => {
        this.setState({ layout: value });
    };

    handleCloseSidebarButton = () => {
        this.setState({ sidebarState: 'close' })
    }


    componentDidMount() {
        if (utils.isElectronBuild()) {
            let currentPath = utils.getCurrentPathName()
            let res = localStorage.getItem("childWindowURl");

            if (currentPath == res) {
                sessionStorage.setItem("isParentWindow", "false")
                localStorage.setItem("childWindowURl", "");
                this.setState({ isChildWindow: true })
                this.setState({ refreshState: new Date()?.toString() })

            }
            else {
                let _isParentWindow = sessionStorage.getItem("isParentWindow")
                if (_isParentWindow == null || _isParentWindow == undefined) {
                    this.setState({ isChildWindow: false })
                }
                if (_isParentWindow == "true") {
                    this.setState({ isChildWindow: false })
                }

                if (_isParentWindow == "false") {
                    this.setState({ isChildWindow: true })
                }

                this.setState({ refreshState: new Date()?.toString() })
            }
        }

        if (window !== undefined) {
            window.addEventListener("resize", this.updateWidth, false);
        }

        if (window.innerWidth > 600 && browser.os != "iOS") {
            let permission = Notification?.permission;
            if (permission?.toString() !== "granted") {
                this.setState({ showNotificationIcon: true })
            }
        }

        // if (browser?.name == "safari") {
        //     this.setState({ showNotificationIcon: false })
        // }

        var hasPermissionOfAnyChatPanel = this.userData?.interfaces?.some(
            (i) =>
                i.interfaceName === Interfaces.OperatorWindow ||
                i.interfaceName === Interfaces.HybridPanel ||
                i.interfaceName === Interfaces.MonitoringPanel
        )

        var flag = localStorage.getItem("isCannedRecieved") || "false"
        // EventEmitter.emit(Events.GetCannedMsgs, "")
        var isElectronBuild = utils.isElectronBuild()

        if (isElectronBuild) {
            if (hasPermissionOfAnyChatPanel && flag != "true") {
                this.refreshCannedMessage()
            }
        }
        else {
            if (hasPermissionOfAnyChatPanel) {
                this.refreshCannedMessage()
            }
        }
    }


    refreshCannedMessage = () => {
        var baseUrl: string = DetectEnvironment.config.REACT_APP_API_BASE_URL!;

        var userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;
        var test = new CannedWorker(this.loadCannedMessages, 100);
        test.start(userData, baseUrl);

    }
    loadCannedMessages = async (data) => {
        try {
            EventEmitter.emit(Events.GetCannedMsgs, data)
            localStorage.setItem("isCannedRecieved", "true")

            // var userData = JSON.parse(localStorage.getItem("USER_DATA")!) as LoginResponse;

            // var result = await wglcsApiService.getcannmessagesbyuserid_new({
            //     userId: userData?.userLoginData?.userId,
            //     languageId: userData?.userLoginData?.languageId,
            // });

            // if (result?.data?.data?.length > 0) {
            //     localStorage.setItem("isCannedRecieved", "true")
            //     var dt = result?.data?.data?.map(x => ({ ...x, messageText: x.descr, messageID: x.id, websiteId: x.webSiteId }))
            //     EventEmitter.emit(Events.GetCannedMsgs, dt)
            // }
            // else {
            //     localStorage.setItem("isCannedRecieved", "false")
            // }
        }
        catch (e) {
            // this.loadCannedMessages()
        }
    }

    componentWillUnmount() {
        if (window !== undefined) {
            window.removeEventListener("resize", this.updateWidth, false);
        }
    }

    toggleSidebarMenu = (sidebarState) => {
        if (sidebarState) {
            this.setState({ sidebarState: "open", layoutMaskValue: 'layout-mask show-mask-layout' });
        }
        else {
            this.setState({ sidebarState: "close", layoutMaskValue: 'layout-mask' });
        }
    }

    layoutMask = (value) => {
        if (value == true) {

            return this.setState({ layoutMaskValue: 'layout-mask show-mask-layout' })
        } else {
            return this.setState({ layoutMaskValue: 'layout-mask' })
        }
    }

    getStyleClasses = () => {
        var path = utils.getCurrentPathName();
        if (path === "/chat/:chatid" || path === "/hybridChat") {
            return "main-wrapper";
        }
        return "";
    };
    expandSidebar = () => {
        if (utils.isElectronBuild()) {
            if (this.state.isChildWindow) {
                return "wrapper wrapper-padding"
            }
        }

        if (this.state.callBackValue == '') {
            return 'wrapper menu-collapsed'
        }
        else {
            return 'wrapper menu-collapsed expand-wrapper'
        }
    }
    expandSidebarCallback = (sidebarState) => {
        this.setState({ callBackValue: sidebarState })
    }
    getWrappperClasses = () => {
        var path = utils.getCurrentPathName();
        if (path === "/chat/:chatid" || path === "/hybridChat" || path === "/monitoringPanel" || utils.isQcMasterPanelActive()) {
            return "wrapper-class";
        }
        return "";
    };

    closeCustomizerMenu = () => {
        EventEmitter.emit(Events.CloseCustomizer, "")
    }

    notificationPermission = (e) => {
        let permission = Notification.permission;
        if (permission?.toString() === "denied") {
            this.notificationHelpOverLay.toggle(e)
        }


        if (permission?.toString() === "default") {
            Notification.requestPermission();
        }


        if (permission?.toString() !== "granted") {
            Notification.requestPermission();
        }
    }

    onScroll = (e) => {
        const currentScrollY = e.target.scrollTop;
        if (currentScrollY > 96) {

            EventEmitter.emit(Events.removeMarginOfSideBar, true)
        }
        else {
            EventEmitter.emit(Events.removeMarginOfSideBar, false)
        }
    };




    getActiveWindow = () => {
        if (utils.isElectronBuild()) {

            let _isParentWindow = sessionStorage.getItem("isParentWindow")

            if (_isParentWindow == null || _isParentWindow == undefined) {
                return true
            }
            if (_isParentWindow == "true") {
                return true
            }

            if (_isParentWindow == "false") {
                return false
            }

            return false
        }
        return true
    }


    render() {
        return (

            <div
                onScroll={this.onScroll}
                className={classnames(this.expandSidebar(), this.getWrappperClasses(), {
                    [`${templateConfig.sidebar.size}`]: this.state.sidebarSize === "",
                    [`${this.state.sidebarSize}`]: this.state.sidebarSize !== "",
                    [`${templateConfig.layoutColor}`]: this.state.layout === "",
                    [`${this.state.layout}`]: this.state.layout !== "",
                })}
            >

                {!this.state.isChildWindow && <Sidebar
                    maskLayout={(value) => this.layoutMask(value)}
                    toggleSidebarMenu={this.toggleSidebarMenu}
                    sidebarState={this.state.sidebarState}
                    sideBarButton={this.handleCloseSidebarButton}
                    handleSidebarSize={this.handleSidebarSize}
                    handleLayout={this.handleLayout}
                    sideBarExpandCallback={(val) => this.expandSidebarCallback(val)}
                />}

                <Navbar maskLayout={(value) => this.layoutMask(value)} toggleSidebarMenu={this.toggleSidebarMenu} />
                <main className={this.getStyleClasses()} onClick={this.closeCustomizerMenu}>
                    {" "}
                    {this.props.children}
                    <div className={this.state.layoutMaskValue}></div>
                </main>
                {this.state.showNotificationIcon &&
                    <span className="parent allow-notification-icon" style={{ cursor: "pointer" }} onClick={this.notificationPermission}>
                        <span><i className="fa fa-bell"></i></span>
                    </span>
                }
                <OverlayPanel className="notifications-overlay" ref={(el) => this.notificationHelpOverLay = el} showCloseIcon id="overlay_panel">
                    <h6>Unblock Notification</h6>
                    <p>Follow these instructions to allow notification</p>
                    {browser.name !== "safari" ?
                        (<>
                            <img
                                className=""
                                src={process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_HELP_IMAGE}
                                alt="bg-image01"
                                style={{ width: "100%" }}
                            /></>)
                        :
                        (<>
                            <img
                                className=""
                                src={process.env.PUBLIC_URL + "/image/" + DetectEnvironment.config.REACT_APP_HELP_IMAGE_FOR_SAFARI}
                                alt="bg-image01"
                                style={{ width: "100%" }}
                            />
                        </>)
                    }
                </OverlayPanel>

            </div>
        );
    }
}

export default MainLayout;
